import Vue from 'vue'
import LoadingBarModel from './LoadingBar.vue'
import LoadingModel from './Index.vue'

const LoadingBar = Vue.extend(LoadingBarModel);
const Loading = Vue.extend(LoadingModel);

Vue.directive('loading-bar', {
    bind: function (el) {
        el.instance = new LoadingBar({
            el: document.createElement('div')
        })

        el.appendChild(el.instance.$el)
    },
    update: function (el, bingding) {
        el.instance.visible = bingding.value;
    },
    unbind: function (el) {
        el.instance.visible = false
    }
})

/* 全局方法 */
let instance;
const initInstance = () => {
    instance = new Loading({
        el: document.createElement('div')
    })

    document.body.appendChild(instance.$el)
}

const parseOptions = option => typeof option === 'object' ? option : { visible: option };

/**
 * loading全局方法
 * @param {Boolean} options 
 */
const LoadingFn = options => {
    /* 单例 */
    if (!instance) {
        initInstance()
    }

    options = {
        ...parseOptions(options)
    }

    Object.assign(instance, options)

    return instance;
}

Vue.prototype.$loadingGif = LoadingFn


// WEBPACK FOOTER //
// ./src/components/loading/index.js